import { motion } from "framer-motion";
import { lists } from "./index.js";
export const IndustriesAndProfessionalWeServe = () => {
  return (
    <section className="   space-y-14 px-5 md:px-10 ">
        <div className=" mx-auto md:w-11/12 lg:w-10/12 xl:w-9/12  ">

      <motion.h2 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
        className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] text-center  font-bold text-dark font-butler"
        >
Industries and Professionals We Serve with CMS Development      </motion.h2>

        </div>
      <ul className="grid  md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-8 ">
        {lists.map((list, index) => {
          return (
            <li key={index}>
              <article className="bg-white  transition-all duration-300 ease-in hover:bg-[#FFC067] cursor-pointer drop-shadow-xl flex  rounded-lg px-5 py-5 w-12/12 items-center space-x-5 h-full">
                <div className="w-2/12 ">
                  <img src={list.icon} alt={list.text} className="w-8 " />
                </div>
                <motion.div
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.3 }}
                  className=" w-12/12 md:w-12/12 xl:w-10/12  "
                >
                  <p className="text-base leading-[1.625rem]">{list.text}</p>
                </motion.div>
              </article>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
